module.exports = __webpack_public_path__ + "0d264b398dfe8134df43c47af5af3e1a.ttf";